import React, { useEffect } from 'react';
import { NotLoggedInPage, Spinner } from '@ydistri/ds';
import { Navigate } from 'react-router';
import Auth from '../../auth/Auth';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { hasMsalResponseParams } from './hasMsalResponseParams';

const Callback: React.FC = () => {
  const auth = new Auth();
  const isPopupCallback = window.opener !== null && window.opener !== window;
  const isMsalPopupWindow = window.name.toLowerCase().includes('msal');
  const hasMsalResponse =
    hasMsalResponseParams(window.location.search) || hasMsalResponseParams(window.location.hash);
  const shouldClosePopup = isPopupCallback || isMsalPopupWindow;

  useEffect(() => {
    if (!hasMsalResponse) {
      return;
    }

    broadcastResponseToMainFrame()
      .catch((error: unknown) => {
        /* eslint-disable-next-line no-console -- for debugging in case of error */
        console.error('Error broadcasting response:', error);
      })
      .finally(() => {
        if (shouldClosePopup) {
          window.close();
        }
      });
  }, [hasMsalResponse, shouldClosePopup]);

  if (shouldClosePopup && hasMsalResponse) {
    return <Spinner />;
  }

  if (auth.isAuthenticated()) {
    return <Navigate to="/" />;
  }

  return (
    <NotLoggedInPage title="Y'app - callback" inputs={[]} submitting={false}>
      <a href="/login">Back to login</a>
    </NotLoggedInPage>
  );
};

export default Callback;
